var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React from "react";
import Box from "../Grid/Box";
const tags = {
    semiTitle: "h3",
    default: "div",
};
/** @type {import('theme-ui').ThemeUIStyleObject} */
const nowrapStyle = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
};
/**
 *
 * @param {object} props
 * @param {import('./textVariants').TextVariants} [props.variant]
 * @param {any} [props.as]
 * @param {string} [props.variants] Uses another set of variants if set. Set to 'p' or 'text' for example.
 * @param {boolean} [props.lowContrast] Uses a lowContrast font variant.
 * @param {boolean} [props.nowrap] Avoids text wrapping.
 * @param {React.ReactNode} props.children The text to display.
 * @param {import('theme-ui').ThemeUIStyleObject} [props.sx] SX props to apply to the text.
 * @param {string} [props.className] CSS class to apply to the text.
 * @returns {React.ReactElement}
 */
function Text(_a, ref) {
    var { variant = "default", as = tags[variant] || tags.default, variants = "text", lowContrast = false, nowrap = false, children } = _a, rest = __rest(_a, ["variant", "as", "variants", "lowContrast", "nowrap", "children"]);
    return (_jsx(Box, Object.assign({ as: as }, rest, { sx: Object.assign({ variant: `${variants}.${variant}`, fontWeight: lowContrast ? "lowContrast" : undefined }, (nowrap && nowrapStyle)), ref: ref, children: children })));
}
export default React.forwardRef(Text);
//# sourceMappingURL=Text.js.map